import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isClientPortalUser } from '../utils/isClientPortalUser';
import { defaultLandingPath } from '../utils/userDashboardPermissions';
import { getUserRole } from '../utils/sessionStore';

/**
 * Default-deny shell for all admin routes. Client portal paths are registered
 * outside this layout in AfterLoginRoutes.
 */
export default function AdminShell() {
  const { isLoading, isAuthenticated: authed } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  if (isClientPortalUser()) {
    return <Navigate to={defaultLandingPath(getUserRole())} replace />;
  }

  return <Outlet />;
}
